import { CommonModule } from '@angular/common'
import { Component, Input, OnInit } from '@angular/core'
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { RoleEnum } from '@core/enums'
import { SvgIconComponent } from 'angular-svg-icon'
import { AccountService, WebSocketService } from '@core/services'
import { SmSpinnerComponent } from '@shared/components'
import { RoutePathEnum } from '@shared/enums'
import { RouteManagerService, SpinnerService } from '@shared/services'

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, SmSpinnerComponent, RouterModule, SvgIconComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.sass',
})
export class LoginComponent implements OnInit {
  routePath = RoutePathEnum
  form = this._formBuilder.group({
    username: ['', Validators.required],
    password: ['', [Validators.required]],
  })

  usernameErrors: any
  passwordErrors: any
  isLoginFailed = false
  isLoading = false
  errorMessage: any

  constructor(
    private _formBuilder: FormBuilder,
    private _accountService: AccountService,
    private _routeManagerService: RouteManagerService,
    private _spinnerService: SpinnerService,
  ) {}

  ngOnInit(): void {
    this._routeManagerService.redirect()
  }

  onLogin() {
    try {
      const username = this.form.get('username')
      const password = this.form.get('password')
      this.isLoginFailed = false
      this.isLoading = true

      this.usernameErrors = {
        required: username?.errors?.['required'] === true,
      }

      this.passwordErrors = {
        required: password?.errors?.['required'] === true,
      }

      this.isLoading = this.form.valid

      if (!this.form.valid) {
        return
      }

      this._accountService.login(username?.value || '', password?.value || '').subscribe({
        next: () => {
          window.location.reload()
        },
        error: (i) => {
          this.isLoginFailed = true
          this.isLoading = false
          this.errorMessage = i.error.message
          this._spinnerService.hideSpinner()
        },
        complete: () => (this.isLoading = false),
      })
    } catch (error) {
      console.error(error)
      this.isLoading = false
      this._spinnerService.hideSpinner()
    }
  }
}
